import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-grey-1 q-pa-lg" }
const _hoisted_2 = { class: "text-h6 q-mb-md q-mt-none" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-weight-regular" }, "Step 1:", -1)
const _hoisted_4 = { class: "text-body1 q-mb-md" }
const _hoisted_5 = { class: "text-body1 q-mb-md" }
const _hoisted_6 = { class: "text-h6 q-mb-md q-mt-none" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-weight-regular" }, "Step 2:", -1)
const _hoisted_8 = { class: "text-body1 q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_instructions = _resolveComponent("instructions")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_file_list = _resolveComponent("file-list")!
  const _component_message = _resolveComponent("message")!
  const _component_async_error_message = _resolveComponent("async-error-message")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, [
              _createVNode(_component_q_icon, {
                name: "fa fa-download",
                class: "on-left"
              }),
              _hoisted_3,
              _createTextVNode(" Export & Download Your Posts ")
            ]),
            _createElementVNode("div", _hoisted_4, " The first step of getting your posts into Private Footprint is exporting them from " + _toDisplayString(_ctx.platform.name) + ". ", 1),
            _createElementVNode("div", _hoisted_5, " Get step by step instructions on how to export your posts from " + _toDisplayString(_ctx.platform.name) + " by selecting an option below. ", 1),
            _createVNode(_component_instructions, {
              platform: _ctx.platform.type
            }, null, 8, ["platform"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_card, { class: "q-mt-lg" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_6, [
              _createVNode(_component_q_icon, {
                name: "fa fa-upload",
                class: "on-left"
              }),
              _hoisted_7,
              _createTextVNode(" Upload Your Posts ")
            ]),
            _createElementVNode("div", _hoisted_8, " When you have downloaded your " + _toDisplayString(_ctx.platform.name) + " posts, please upload them here. ", 1),
            _createVNode(_component_file_list, {
              files: _ctx.uploadedFiles,
              "max-files": 1,
              "upload-placeholder": "Drag .zip file here or click to upload",
              "allowed-extensions": ['zip'],
              validate: _ctx.validateFile,
              class: "q-mt-lg",
              "can-upload": "",
              "can-delete": "",
              "onUpdate:files": _ctx.onFilesChanged
            }, null, 8, ["files", "validate", "onUpdate:files"]),
            (_ctx.error)
              ? (_openBlock(), _createBlock(_component_message, {
                  key: 0,
                  type: "negative",
                  class: "q-my-md"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.error), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_async_error_message, {
              task: _ctx.task,
              class: "q-my-md"
            }, null, 8, ["task"]),
            _createVNode(_component_loader, {
              task: _ctx.task,
              class: "q-my-md"
            }, null, 8, ["task"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}